import React from 'react'
import { Box, SxProps, Theme } from '@mui/material'

type WidthPreset = 'xs' | 'sm' | 'md' | 'lg' | 'full'

interface SectionLayoutProps {
  children: React.ReactNode
  width?: WidthPreset | number
  bg?: string
  px?: number | string | object
  py?: number | string | object
  pt?: number | string | object
  sx?: SxProps<Theme>
  noPaddingTop?: boolean
  component?: React.ElementType
  dataGTM?: string
}

const widthMap: Record<WidthPreset, number | string> = {
  xs: 600,
  sm: 800,
  md: 1200,
  lg: 1600,
  full: '100%'
}

function getBgStyles(bg?: string) {
  if (bg?.startsWith('url(')) {
    return {
      backgroundImage: bg,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }
  }
  return { background: bg }
}

const SectionLayout: React.FC<SectionLayoutProps> = ({
  children,
  width = 'md',
  bg = '#181818',
  px = { xs: 2.5, sm: 8, lg: 12 },
  py = { xs: 8, sm: 12 },
  pt,
  noPaddingTop = false,
  component,
  dataGTM,
  sx = {}
}) => {
  const resolvedWidth =
    typeof width === 'string' && widthMap[width as WidthPreset] ? widthMap[width as WidthPreset] : width

  return (
    <Box
      component={component || 'section'}
      sx={{
        ...getBgStyles(bg),
        px,
        py,
        pt: noPaddingTop ? { xs: 0, sm: 0, lg: 0 } : pt,
        ...sx
      }}
    >
      <Box
        data-gtm-click-subsection1={dataGTM}
        sx={{
          maxWidth: resolvedWidth,
          mx: 'auto'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default SectionLayout
